import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaDiscord } from 'react-icons/fa';
import '../styles/Login.css';

const Login = () => {
    const { isAuthenticated } = useAuth();
    const API_URL = process.env.REACT_APP_API_URL || '';

    // Redirect if already authenticated
    if (isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    const handleDiscordLogin = () => {
        window.location.href = `${API_URL}/auth/discord`;
    };

    return (
        <div className="login-page">
            <div className="login-background">
                <div className="login-overlay"></div>
            </div>
            
            <div className="login-container">
                <div className="login-card">
                    <div className="login-header">
                        <div className="login-logo">
                            <span className="logo-emoji">🏙️</span>
                        </div>
                        <h1>RVN City</h1>
                        <p className="login-subtitle">Admin Log Dashboard</p>
                    </div>

                    <div className="login-content">
                        <p className="login-description">
                            Sign in with your Discord account to access the admin dashboard.
                            Only users with Admin role can access this system.
                        </p>

                        <button 
                            className="discord-login-btn"
                            onClick={handleDiscordLogin}
                        >
                            <FaDiscord className="discord-icon" />
                            <span>Login with Discord</span>
                        </button>

                        <div className="login-info">
                            <p>🔒 Secure authentication via Discord OAuth2</p>
                            <p>👮 Admin role verification required</p>
                        </div>
                    </div>

                    <div className="login-footer">
                        <p>© 2024 RVN City. Internal use only.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
